import { createContext, useEffect, useRef, useState } from 'react';

import { Map as olMap, View } from 'ol';
import { Group as layerGroup, Tile as TileLayer } from 'ol/layer';
import { Attribution, defaults as defaultControls } from 'ol/control';
import { defaults as defaultInteractions } from 'ol/interaction';

import { GeoJSON } from 'ol/format';
import axios from 'axios';
import { setClickEvent, matchView } from '../common/layer';

const MapContext = createContext({
	popUpValue: null,
	sggMap: null,
	emdMap: null,
	weightedMap: null,

	popupRef: null,
});

const MapProvider = ({ children }) => {
	const [sggPopupValue, setSggPopupValue] = useState(null);
	const [emdPopupValue, setEmdPopupValue] = useState(null);
	const [weightedPopupValue, setWeightedPopupValue] = useState(null);
	const [sggMap, setSggMap] = useState(null);
	const [emdMap, setEmdMap] = useState(null);
	const [weightedMap, setWeightedMap] = useState(null);
	const [weightedMapLayers, setWeightedMapLayers] = useState(null);

	const createMap = (id, bgLayer, targetLayer) => {
		const map = new olMap({
			target: id,
			view: matchView[id],
			layers: [
				new layerGroup({
					name: 'bgMap',
					layers: [bgLayer],
				}),
				new layerGroup({
					name: `${id}Layers`,
					layers: Object.keys(targetLayer).map((key) => targetLayer[key]),
				}),
			],
			controls: defaultControls({ zoom: false, attribution: false }).extend([
				new Attribution({ collapsible: false }),
			]),
			interactions: defaultInteractions().extend([]),
		});

		const matchSetter = {
			sggMap: setSggPopupValue,
			emdMap: setEmdPopupValue,
			weightedMap: setWeightedPopupValue,
		};

		map.on('click', (e) => {
			const viewResolution = map.getView().getResolution();
			setClickEvent(e, viewResolution, targetLayer, matchSetter[id]);
		});

		return map;
	};

	// const removeMap = (ref, type) => {
	// 	ref.current = null;
	// 	if ((type = 'sgg')) {
	// 		maps.sggMap = null;
	// 	} else if ((type = 'emd')) {
	// 		maps.emdMap = null;
	// 	} else {
	// 		maps.weightedMap = null;
	// 	}
	// };

	// const pointerClickEvent = (
	// 	e,
	// 	map,
	// 	layers,
	// 	type,
	// 	emdCode,
	// 	pop,
	// 	consume,
	// 	prod
	// ) => {
	// 	setPopupValue(null);
	// 	const viewResolution = map.getView().getResolution();
	// 	const url = layers.current[
	// 		`${type ? `vi_${type}` : emdCode === '' ? 'vi_sgg' : 'vi_emd'}`
	// 	]
	// 		.getSource()
	// 		.getFeatureInfoUrl(e.coordinate, viewResolution, 'EPSG:3857', {
	// 			INFO_FORMAT: 'application/json',
	// 		});
	// 	//
	// 	if (url) {
	// 		fetch(url)
	// 			.then((res) => res.json())
	// 			.then((json) => {
	// 				//
	// 				if (json.features.length > 0) {
	// 					const data = json.features[0].properties;
	// 					let regionName;
	// 					let regionVal;
	// 					let weightedVal;
	// 					let popVal;
	// 					let consumeVal;
	// 					let prodVal;

	// 					if (emdCode !== '') {
	// 						regionName = data.amd_nm;
	// 						regionVal = data.vi.toFixed(2);
	// 						popVal = data.m12.toFixed(2);
	// 						consumeVal = data.m34.toFixed(2);
	// 						prodVal = data.m56.toFixed(2);
	// 					} else if (type === 'emd') {
	// 						regionName = data.amd_nm;
	// 						regionVal = data.vi.toFixed(2);
	// 						popVal = data.m12.toFixed(2);
	// 						consumeVal = data.m34.toFixed(2);
	// 						prodVal = data.m56.toFixed(2);
	// 					} else {
	// 						regionName = `${data.sido_nm_k} ${data.sgg_nm_k}`;
	// 						regionVal = data.lv1_all.toFixed(2);
	// 						popVal = data.l1_1.toFixed(2);
	// 						consumeVal = data.l1_2.toFixed(2);
	// 						prodVal = data.l1_3.toFixed(2);
	// 					}

	// 					if (pop === 1 && consume === 1 && prod === 1) {
	// 						setPopupValue({
	// 							weighted: false,
	// 							regionName,
	// 							regionVal,
	// 							popVal,
	// 							consumeVal,
	// 							prodVal,
	// 						});
	// 					} else {
	// 						weightedVal = (
	// 							(popVal * pop + consumeVal * consume + prodVal * prod) /
	// 							(pop + consume + prod)
	// 						).toFixed(2);
	// 						setPopupValue({
	// 							weighted: true,
	// 							regionName,
	// 							weightedVal,
	// 							regionVal,
	// 							popVal,
	// 							consumeVal,
	// 							prodVal,
	// 						});
	// 					}
	// 				} else {
	// 					setPopupValue(null);
	// 				}
	// 			});
	// 	}
	// };
	// const rebootPointerClickEvent = (
	// 	eventKey,
	// 	setEventKey,
	// 	map,
	// 	layers,
	// 	type,
	// 	emdCode,
	// 	pop,
	// 	consume,
	// 	prod
	// ) => {
	// 	const mapElement = document.querySelector('#weightedMap');
	// 	if (mapElement) {
	// 		const contains = mapElement.classList.contains('PCE');
	// 		if (contains) {
	// 			unByKey(eventKey);
	// 			map.un('click', pointerClickEvent);
	// 		} else {
	// 			mapElement.classList.add('PCE');
	// 		}
	// 	}
	// 	const key = map.on('click', (e) => {
	// 		return pointerClickEvent(
	// 			e,
	// 			map,
	// 			layers,
	// 			type,
	// 			emdCode,
	// 			pop,
	// 			consume,
	// 			prod
	// 		);
	// 	});
	// 	setEventKey(key);
	// };

	const matchLayer = {
		sido_cd: 'vi_sgg',
		sgg_cd: 'vi_sgg',
		amd_cd: 'vi_emd',
		// sido_cd: 'bnd_sido_sim_202112',
		// sigungu_cd: 'bnd_sigungu_sim_202112',
		// adm_cd: 'bnd_dong_sim_202112',
	};

	const getFeatures = async (code, targetField) => {
		const vectorUrl = `${process.env.REACT_APP_GISSERVER_PATH}?service=WFS&version=1.0.0&request=GetFeature&outputFormat=application/json&srsName=EPSG:3857&typeName=pinogio:${matchLayer[targetField]}&cql_filter=${targetField} in (${code})`;
		let result;
		await axios
			.get(vectorUrl)
			.then((res) => {
				const resData = JSON.stringify(res.data);
				const features = new GeoJSON().readFeatures(resData);
				result = features;
			})
			.catch((err) => console.log(err));
		return result;
	};

	return (
		<MapContext.Provider
			value={{
				sggPopupValue,
				emdPopupValue,
				weightedPopupValue,
				sggMap,
				emdMap,
				weightedMap,
				weightedMapLayers,

				setSggPopupValue,
				setEmdPopupValue,
				setWeightedPopupValue,
				setSggMap,
				setEmdMap,
				setWeightedMap,
				setWeightedMapLayers,

				createMap,
				// removeMap,
				// pointerClickEvent,
				// rebootPointerClickEvent,
				getFeatures,
			}}
		>
			{children}
		</MapContext.Provider>
	);
};

export { MapContext, MapProvider };
